
const validatePostalCode = (postalcode) => {

  // Validate the postal code format
  const isValidPostalCode = /^\d{4}[A-Za-z]{2}$/.test(postalcode);

  if (isValidPostalCode || postalcode === '') {
    console.log("Geldige Postcode")
    return true; // Postcode is geldig

  } else {
    console.log("Ongeldige Postcode")
    return false; // Postcode is ongeldig
  }
};





export {  validatePostalCode };